// global mixin
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      setting: 'global/setting'
    }),
    dark () {
      return this.setting('dark')
    }
  }
}
